import React from "react";
import { getCmsData } from "../../../functions";

const Events = () => {
  const cmsData = getCmsData("homepageEventsDataCMS");
  if (!cmsData) return null;

  const { visibility, heading, headingURL, cards } = cmsData;

  if (!visibility || !cards || cards?.length === 0) {
    return null;
  }

  return (
    <div id="Events">
      <h2>{heading}</h2>
      <div className="view-all-news-link">
        <span className="heading-divider"></span>
        <a href={headingURL}>
          View all events<span className="arrow-right"></span>
        </a>
      </div>
      <div className="container-fluid">
        <div className="row">
          {cards.map((card, id) => (
            <div
              className="col-12  col-md-4  d-flex align-items-stretch"
              key={id}
            >
              <div className="single-card" tabIndex="0">
                <a href={card.URL}>
                  <div className="image-container">
                    <div
                      className="image"
                      aria-label=""
                      style={{ backgroundImage: `url(${card.imageURL})` }}
                    >
                      <span>Event</span>
                    </div>
                  </div>
                  <div className="text-container">
                    <h3>{card.heading}</h3>
                    <span className="events-tile-date">
                      {card.startDate}
                      {card.endDate && ` - ${card.endDate}`}
                    </span>
                    <p>{card.description}</p>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Events;
